import React, { useEffect, Fragment, useState } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Provider } from 'react-redux'
import { Router } from "react-router-dom"
import { userRefresh, clearUser } from './actions/user'
import { closePopup, openPopup } from "./actions/popup"
import { closeSnackbar, openSnackbar } from './actions/snackbar'
import UserLogin from './components/UserLogin'
import AdminReport from './components/AdminReport'
//import InMenu from './components/InMenu';
import UnderMenu from './components/UnderMenu'
import ProfileDS from './components/ProfileDS'
import InfoDS from './components/InfoDS'
import DocumentsDS from './components/DocumentsDS'
import UserController from './components/UserController'
import Popup from './components/Popup'
import Snackbar from './components/Snackbar'

function App({userRefresh, closePopup, user, popup, store, lang, history, openPopup, clearUser, openSnackbar}) {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const admrepClick = () => {
        if (window.screen.width < 1366)
            window.scrollTo(0, 0)
        openPopup('Связь с администратором', <AdminReport/>);
    }
    const [admrep_isLoad, set_admrep_load_status] = useState(false)
    let admrep = document.querySelectorAll('.nolink')

    useEffect(() => {
        if (admrep && !admrep_isLoad) {
            set_admrep_load_status(true)
            admrep.forEach(el => {
                el.addEventListener('click', admrepClick)
                el.text = ''
            })
        }
    }, [admrep])

    window.onload = () => {

        const btnUnderMenu2 = document.querySelector('.cat-menu').querySelector('#auth-under-menu');

        const heading = document.querySelector(".cell_wrapper");
        if ((!heading || !heading.querySelector('h1').innerHTML === 'Страница не найдена') && !isFirefox) {
            const btnUnderMenu2 = document.querySelector('.cat-menu').querySelector('#auth-under-menu');
            ReactDOM.render(
                <React.StrictMode>
                    <Provider store={store}>
                        <Router history={history}>
                            <UnderMenu history={history} lang={lang}/>
                        </Router>
                    </Provider>
                </React.StrictMode>,
                btnUnderMenu2
            );
        }
        if (window.location.href.includes('recover')) {
            document.querySelector('.cell_wrapper > h1').innerHTML = "Восстановление пароля"
            document.querySelector('#block-system-main > div').innerHTML = ""
            document.title = "Восстановление пароля | Леса высокой природоохранной ценности (ЛВПЦ) России";
        }
        if (btnUnderMenu2) {
            ReactDOM.render(
                <React.StrictMode>
                    <Provider store={store}>
                        <Router history={history}>
                            <UnderMenu history={history} lang={lang}/>
                        </Router>
                    </Provider>
                </React.StrictMode>,
                btnUnderMenu2
            );
        }

        const info_ds = document.querySelector('#info_ds')
        if (info_ds) {
            ReactDOM.render(
                <React.StrictMode>
                    <Provider store={store}>
                        <Router history={history}>
                            <InfoDS history={history}/>
                        </Router>
                    </Provider>
                </React.StrictMode>,
                info_ds
            )
        }
        const documents_ds = document.querySelector('#documents_ds')
        if (documents_ds) {
            ReactDOM.render(
                <React.StrictMode>
                    <Provider store={store}>
                        <Router history={history}>
                            <DocumentsDS history={history}/>
                        </Router>
                    </Provider>
                </React.StrictMode>,
                documents_ds
            )
        }
    }

    useEffect(() => {
        if (window.location.href.includes('reg_success=true')) {
            clearUser()
            const url = new URL(window.location.href)
            window.history.replaceState({}, document.title, url.origin + url.pathname)
            openPopup('Авторизация', <UserLogin lang={lang}/>);
        } else {
            userRefresh()
        }
    }, [userRefresh]);

    useEffect(() => {
        admrep.forEach(el => {
            if (user.status !== 'confirmed')
                el.text = ''
            else
                el.text = 'Связь с администратором'
        })

        if (user.status === 'unknown') {
            return;
        }
        let isAccessLPO = false;
        if (user.status === "confirmed") {
            isAccessLPO = user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.accessLPO;
        }

        const href = window.location.href;
        const isUserConfirmed = user.status === 'confirmed';
        const isRoleAdminLPO = user.role === "a436a766765eabad209d971014b41999b";
        const isRoleSpecLPO = user.role === "b3940d35edbbb3d8204f1b820a87d8e12";

        const isRoleZS = user.role === "d624642affcb83df0c87471e41ca557df";
        const isRoleDS = user.role === "e249a07138dd45d3f4ba27d90d6c2244d";
        const isRoleAuditor = user.role === "eeb43e3d0be1d6e8bb92aa704092f9df1";
        const isRoleMonitor = user.role === "f23d9209a63265defaeda6693d6f4b94d";

        let content = document.querySelector('#main #block-system-main .content') || document.querySelector('#profile_ds')
        if (!content) return
        else if (href.includes('/onewin') && isUserConfirmed && (isRoleZS || isRoleDS || isRoleAuditor || isRoleMonitor)) {
            content.innerHTML = `<iframe id="iframe_map" width="100%" height="500" src='https://hcvf.citorus.ru:8889/public/oneWin?uid=${user.data._id}' frameborder="0" class="hcvf-map"></iframe>`;
        } else if (href.includes('/lpo') && isUserConfirmed && (isRoleSpecLPO || isRoleAdminLPO || isAccessLPO)) {
            content.innerHTML = `<iframe id="iframe_map" width="100%" height="500" src="https://hcvf.citorus.ru:8889/public/wwf-lpo/lpo?uid=${user.data._id}" frameborder="0" class="hcvf-map"></iframe>`;
            //
            // const validUserNames = ["teamvolg", "R001"];
            // const userName = user.data.name;
            // const isAccessNewModule = validUserNames.includes(userName);
            // if (isAccessNewModule) {
            //     content.innerHTML = `<iframe id="iframe_map" width="100%" height="500" src="https://hcvf.citorus.ru:8889/public/wwf-lpo/lpo?uid=${user.data._id}" frameborder="0" class="hcvf-map"></iframe>`;
            // } else {
            //     content.innerHTML = `<iframe id="iframe_map" width="100%" height="500" src="https://hcvf.citorus.ru:8889/public/fsc_new?uid=${user.data._id}" frameborder="0" class="hcvf-map"></iframe>`;
            // }
        } else if (href.includes('/profile_ds') && isUserConfirmed && isRoleDS) {
            content.innerHTML = `<iframe style="height:1400px;" width="100%" src="https://hcvf.citorus.ru:8889/public/profile_ds?uid=${user.data._id}" frameborder="0" class="hcvf-map"></iframe>`;
        } else if (href.includes('/onewin')) {
            content.innerHTML = `<p class="embedded-content">Данная страница доступна авторизованным пользователям роли <br/> "Держатель сертификата (ДС)", "Заинтересованная сторона (ЗС)", "Наблюдатель" или "Аудитор". ${!isUserConfirmed ? "<br/><br/>Выполните вход." : ""}</p>`
        } else if (href.includes('/lpo')) {
            content.innerHTML = `<p class="embedded-content">Данная страница доступна авторизованным пользователям роли <br/> "Специалист оцифровки актов ЛПО". ${!isUserConfirmed ? "<br/><br/>Выполните вход." : ""}</p>`;
        } else if (href.includes('/profile_ds')) {
            content.innerHTML = `<p class="embedded-content">Данная страница доступна авторизованным пользователям роли <br/> "Держатель сертификата (ДС)". ${!isUserConfirmed ? "<br/><br/>Выполните вход." : ""}</p>`;
        }

    }, [user])


    useEffect(() => {
        window.addEventListener('message', message)
        return () => {
            window.removeEventListener('message', message)
        };
    }, [])


    const message = (e) => {
        if (e.origin === `https://hcvf.citorus.ru:8889`) {
            console.log(e)
            if (e.data.name === 'profile_ds') {
                openSnackbar(e.data.msg, e.data.type)
            }
            if (e.data.name === 'adm_report') {
                openSnackbar(e.data.msg, e.data.type)
                if (!e.data.error)
                    closePopup()
            }
        }
    }


    return (
        <Fragment>
            <Snackbar/>
            {popup.display &&
            <Fragment>
                <Popup/>
                <div onClick={() => {
                    closePopup()
                }} className='auth-overlay'></div>
            </Fragment>
            }
            <UserController user={user}/>
        </Fragment>
    )
}

const mapStateToProps = state => ({
    user: state.user,
    popup: state.popup
})

export default connect(mapStateToProps, {
    userRefresh,
    closePopup,
    closeSnackbar,
    openPopup,
    clearUser,
    openSnackbar
})(App)